export const sizeStyle = {
  small: 'h-9',
  medium: 'h-12.5',
  big: 'h-14'
};

export const inputStyles = {
  common:
    'peer p-2 w-full border rounded-lg hover:border-grey focus:outline-none focus:border-primary focus-within:border-primary focus:shadow-inputShadow',
  error: '!border-2 !border-error'
};

export const labelStyles = {
  common:
    'absolute cursor-text left-0 -translate-y-6 text-sm text-content font-medium'
};
